import { render, staticRenderFns } from "./NewOrder.vue?vue&type=template&id=4299c49f&scoped=true"
import script from "./NewOrder.vue?vue&type=script&lang=js"
export * from "./NewOrder.vue?vue&type=script&lang=js"
import style0 from "./NewOrder.vue?vue&type=style&index=0&id=4299c49f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4299c49f",
  null
  
)

export default component.exports